import { Route, Redirect } from "react-router-dom";
import { useAppContext } from "../Libs/contextLib";
import { isUserQM } from "../Libs/helperLib";

export default function WebFormRoute({ component: C, appProps, ...rest }) {
  const { isAuthenticated, currUser } = useAppContext();
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated && isUserQM(currUser) ? (
          <C {...props} {...appProps} />
        ) : (
          <Redirect
            to={`/Error?redirect=${props.location.pathname}${props.location.search}`}
          />
        )
      }
    />
  );
}
